import * as React from "react";
const SvgBook = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.5 0H7.5C6.17441 0.00158786 4.90356 0.528882 3.96622 1.46622C3.02888 2.40356 2.50159 3.67441 2.5 5V20C2.5 21.0609 2.92143 22.0783 3.67157 22.8284C4.42172 23.5786 5.43913 24 6.5 24H17.5C18.8256 23.9984 20.0964 23.4711 21.0338 22.5338C21.9711 21.5964 22.4984 20.3256 22.5 19V5C22.4984 3.67441 21.9711 2.40356 21.0338 1.46622C20.0964 0.528882 18.8256 0.00158786 17.5 0V0ZM20.5 5V16H8.5V2H17.5C18.2956 2 19.0587 2.31607 19.6213 2.87868C20.1839 3.44129 20.5 4.20435 20.5 5ZM6.5 2.172V16C5.79763 15.9994 5.1076 16.1847 4.5 16.537V5C4.50009 4.37969 4.69246 3.77466 5.05063 3.2682C5.40881 2.76175 5.91517 2.37877 6.5 2.172ZM17.5 22H6.5C5.96957 22 5.46086 21.7893 5.08579 21.4142C4.71071 21.0391 4.5 20.5304 4.5 20C4.5 19.4696 4.71071 18.9609 5.08579 18.5858C5.46086 18.2107 5.96957 18 6.5 18H20.5V19C20.5 19.7956 20.1839 20.5587 19.6213 21.1213C19.0587 21.6839 18.2956 22 17.5 22Z",
      fill: "#1B1C1D"
    }
  )
);
export default SvgBook;
